import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'user-avatar.component',
  props: {
    fullName: null,
    imageUrl: null,
    height: null,
    width: null
  },
  setup(__props: any) {

const props = __props as {
  fullName: string;
  imageUrl?: string;
  height: string;
  width: string;
}



const getInitials = computed(() => {
  const words = props.fullName.split(" ").filter((word) => word.length > 0);
  const initials = words.map((word) => word[0].toUpperCase());

  if (initials.length === 1) return `${initials[0]}`;
  return `${initials[0]}${initials[initials.length - 1]}`;
});

return { __sfc: true,props, getInitials }
}

})